import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit} from '@angular/core';
import {ComponentAsElement} from "../../services/common/bootstrap/annotation/component-as-element";
import {CartService} from "../../services/cart.service";
import {iCartPos, iCartPoses} from "../../model/CartModel";
declare const subscriptionsDeliveryMethods: any;
declare const window: any;

@ComponentAsElement('v-cart-poses-element')
@Component({
  selector: 'v-cart-poses',
  templateUrl: './cart-poses.component.html'
})
export class CartPosesComponent implements OnInit {
  @Output() definePos: EventEmitter<null|iCartPoses> = new EventEmitter();
  @Output() definePosSelected: EventEmitter<boolean|string> = new EventEmitter();
  @Input() site;
  @Input() error: string;
  @Input() mode;
  @Input() asmMode: string;
  public selectedPos;
  public cities;
  public poses = [];
  public allPoses;
  public showPosSelectors = false;
  public showPoses = false;
  public showPosInfo = false;
  public showSelectedPos = false;
  public selectedCity = '';

  constructor(private cartService: CartService) {}

  ngOnInit() {
    if(!this.mode) {
      this.cartService.selectedSettings.subscribe(_settings => this.init(_settings));
    }
  }

  ngAfterViewInit() {
    if(this.mode === 'subscriptions') {
      const settings = window.pickupSettings||null;
      this.init(settings);
    }
  }

  init(_settings) {
    const settings = _settings;

    if(settings?.selectedPointOfService) {
      this.selectedPos = settings.selectedPointOfService;
      this.showSelectedPos = true;
      this.definePos.emit(this.selectedPos);
      this.changeElementValidate('');
      this.showPosSelectors = false;

      if(this.mode === 'subscriptions') {
        document.addEventListener('readystatechange', event => {
          if((event.target as HTMLDocument).readyState === "complete") subscriptionsDeliveryMethods.confirmPOS(this.selectedPos.name)
        });
      }

    }
    else if(!this.showPosSelectors && this.site ==='visionexpress') {
      this.cartService.initCities.subscribe(items => {
        this.cities = items;
        this.showPosSelectors = true;
        this.changeElementValidate('city');
      });
    }
    else if(!this.showPosSelectors && (this.site ==='trendyopticians' || this.site ==='grandoptical')) {
      this.selectCity(this.site);
      this.showPosSelectors = true;
    }
  }

  selectCity(_site, _city?) {
    const site = _site;
    const city = _city ? _city : '';

    this.showPoses= false;
    this.poses = [];
    this.selectedCity = city;
    this.cartService.getPoses(site, city).subscribe((poses: iCartPos) => {
      this.poses = poses.poses.map(pos => pos.displayName);
      this.allPoses = poses.poses;
      this.showPoses = true;
      this.showPosInfo = false;
      this.changeElementValidate('pos');
    });
  }

  selectPos(_pos) {
    const pos = _pos;

    this.selectedPos = this.allPoses.filter(item => item.displayName == pos)[0];
    this.showPosInfo = true;
    this.changeElementValidate('confirm');
  }

  selectDelivery(_poscode) {
    const code = _poscode;

    if(!this.mode) {
      this.cartService.changeDelivery('pickup', code).subscribe(() => {
        this.showPosInfo = false;
        this.showPosSelectors = false;
        this.showPoses = false;
        this.showSelectedPos = true;
        this.definePos.emit(this.selectedPos);
      });
      return;
    }

    if(this.mode === 'subscriptions') {
      this.showPosInfo = false;
      this.showPosSelectors = false;
      this.showPoses = false;
      this.showSelectedPos = true;
      subscriptionsDeliveryMethods.confirmPOS(code);
    }
  }

  newPos() {
    if(!this.mode) {
      this.cartService.clearMethods();
      this.definePos.emit(null);
      this.selectedPos = null;
    } else if(this.mode === 'subscriptions') {
      subscriptionsDeliveryMethods.editPickupDeliveryMode();
    }

    this.showPosInfo = false;
    this.showSelectedPos = false;

    if(this.site === 'visionexpress') {
      this.cartService.initCities.subscribe(items => {
        this.cities = items;
        this.showPosSelectors = true;
        this.changeElementValidate('city');
      });
    }
    else {
      this.selectCity(this.site);
      this.showPosSelectors = true;
    }
  }

  changeElementValidate(_element) {
    const element = _element;

    if(!this.mode) this.definePosSelected.emit(element);
    this.error = '';
  }
}
